export default "__VITE_PUBLIC_ASSET__ca558514__"